module.exports = __webpack_public_path__ + "img/chess_chesswhite4.9c3c23dd.png";